import BG from './BG';
import Label from './Label';

const TWEEN = {
    DURATION: 250,
    EASE: Phaser.Math.Easing.Back.Out,
};

export default class Caption extends Phaser.GameObjects.Container {
    private bg!: BG;
    private label!: Label;
    public isDone: boolean = false;

    constructor(scene: Phaser.Scene, x: number, y: number, width: number, text: string) {
        super(scene, x, y);

        this.setupBG();
        this.setupLabel(width, text);
        this.finalize();
    }

    private setupBG(): void {
        this.bg = new BG(this.scene, 0, 0);
        this.add(this.bg);
    }

    private setupLabel(width: number, text: string): void {
        const i18text = this.scene.cache.json.get('i18n')[text];
        this.label = new Label(this.scene, 0, 0, width, i18text);
        this.add(this.label);
    }

    private finalize(): void {
        this.bg.updateSize(this.label.getTextBounds());
        this.setScale(0);
    }

    async start(): Promise<void> {
        this.label.startTyping();

        return new Promise((resolve) => {
            this.label.once('done', () => resolve());
        });
    }

    public finishTyping(): void {
        this.label.stopTyping();
        this.isDone = true;
    }

    public async show(): Promise<void> {
        return new Promise((resolve) => {
            this.scene.tweens.add({
                targets: this,
                duration: TWEEN.DURATION,
                ease: TWEEN.EASE,
                scaleX: 1,
                scaleY: 1,
                onComplete: () => resolve(),
            });
        });
    }

    public dispose(): void {
        this.label.removeAllListeners();
        this.label.dispose();
    }
}
